export default __webpack_public_path__ + "static/media/contact_background_right.f66628a3.png";